export default __webpack_public_path__ + "4a6f52e0f7d83f1724199a4c9aa9e9df.png";